import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import QAndA from "./QAndA";
import { Media, Container, Row, Col } from "reactstrap";
import { joinCss } from "../helpers/utils";

import appClasses from "../App.module.scss";
import classes from "./FAQ.module.scss";

import HeaderImage from "../HeaderImage";
import faqContact from "../images/background.png";
import EnFaqButton from "./EnFaqButton.js";

class FAQ extends Component {
  state = {
    faq: null,
    viewName: {
      firstLine: "שאלות",
      secondLine: "ותשובות"
    }
  };
  componentDidMount() {
    axios.get("/api/faq?lang=he").then(res => {
      this.setState({
        faq: res.data
      });
    });
  }
  render() {
    let faqHtml = "";
    if (this.state.faq && this.state.faq.length > 0) {
      faqHtml = (
        <div className="mb-5">
          {this.state.faq.map(element => (
            <QAndA data={element} key={"QAndA" + element.id} />
          ))}
        </div>
      );
    } else {
      faqHtml = <div className="mb-5">המידע יטען בקרוב...</div>;
    }

    return (
      <Container>
        <HeaderImage viewName={this.state.viewName} button={EnFaqButton} />
        <div className="mt-5">
          {faqHtml}
          <Row>
            <Col className={joinCss("px-0", classes.contactFotter)}>
              <Media
                src={faqContact}
                alt="צור קשר"
                className={classes.faqContact}
              />
              <Container className={classes.footerContainer}>
                <Row>
                  <Col
                    md="8"
                    sm="8"
                    xs="9"
                    className={joinCss(
                      classes.contactTextFotter,
                      appClasses["right-align-div"]
                    )}
                  >
                    לא מצאתם תשובה לשאלתכם?
                  </Col>
                  <Col
                    md="4"
                    sm="4"
                    xs="3"
                    className={joinCss(
                      classes.contactLinkCol,
                      appClasses["right-align-div"]
                    )}
                  >
                    <Link
                      className={classes.contactLink}
                      to={{
                        pathname: "/ContactUs"
                      }}
                    >
                      צרו קשר
                    </Link>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </div>
      </Container>
    );
  }
}

export default FAQ;
